import { createRoutine } from 'redux-saga-routines';

export const stopSagaRoutine = createRoutine<{ [moduleKey: string]: any }>('SAGA/STOP_SAGAS');
